import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Col } from 'reactstrap';
import classnames from 'classnames';

const FormControlStatic = ({ id, className, label, value }) => (
  <FormGroup row className={classnames('form-group-2col', className)}>
    <Label for={id} sm={3} xs={12}>
      {label}
    </Label>
    <Col sm={8} md={6} xs={12}>
      <div className="form-control-static">{value}</div>
    </Col>
  </FormGroup>
);

FormControlStatic.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default FormControlStatic;
